/*
  The button loader animation.
  Change the loading animation here
  to change globally for all the Loader Buttons

  its five verticle bars increasing and descreasing in size.
*/
import React from 'react';

class UpwardButtonLoader extends React.Component {
   constructor(props) {
      super(props);
   }

   render() {
      return (
         <div className='button-spinner'>
            <div className='rect1' />
            <div className='rect2' />
            <div className='rect3' />
            <div className='rect4' />
            <div className='rect5' />
         </div>
      );
   }
}

export default UpwardButtonLoader;
